import { render, staticRenderFns } from "./TradeRequests.vue?vue&type=template&id=6f32e85c&"
import script from "./TradeRequests.vue?vue&type=script&lang=js&"
export * from "./TradeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports